import { render, staticRenderFns } from "./ModalPayFail.vue?vue&type=template&id=53758e5c&scoped=true&"
import script from "./ModalPayFail.vue?vue&type=script&lang=js&"
export * from "./ModalPayFail.vue?vue&type=script&lang=js&"
import style0 from "./ModalPayFail.vue?vue&type=style&index=0&id=53758e5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53758e5c",
  null
  
)

export default component.exports